import { render, staticRenderFns } from "./registration_attachment.vue?vue&type=template&id=49c92e6d&scoped=true&"
import script from "./registration_attachment.vue?vue&type=script&lang=js&"
export * from "./registration_attachment.vue?vue&type=script&lang=js&"
import style0 from "./registration_attachment.vue?vue&type=style&index=0&id=49c92e6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c92e6d",
  null
  
)

export default component.exports